import axios from "axios";


// Create Axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_SERVER, // Change this to your API base URL
});

// Add an interceptor to attach the Bearer Token

axiosInstance.interceptors.request.use(
    (config) => {
         // Skip adding Authorization header for /auth/tokens endpoint
         if (!config.url.includes('/auth/tokens')) {
          config.headers.Authorization = `Bearer ${sessionStorage.getItem("access_token")}`;
          }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => {
      // You can modify successful responses here
      return response;
    },
    (error) => {
      // Handle errors globally
        if (error.response) {
            if (error.response.status === 401) {
                // Redirect to login for 401 Unauthorized
                window.location.href = "/";
            } else if (error.response.status === 403 && error.response.data && error.response.data.redirectUrl) {
                // Redirect to access-denied page for 403 Forbidden
                window.location.href = error.response.data.redirectUrl; 
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.error("No response received:", error.request);
        } else {
            // Something happened in setting up the request
            console.error("Request setup error:", error.message);
        }
        return Promise.reject(error);
    }
  );
export default axiosInstance;
